enum MessageSender {
  Host = "Host",
  Sandbox = "Sandbox",
}
export default MessageSender;
